var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"DxpNavBar__List"},_vm._l((_vm.itemList),function(item,i){return _c('li',{key:`navbar_item_${i}`,staticClass:"DxpNavBar__ListItem",attrs:{"id":`navbar_item_${i}`}},[_c('a',{class:[
        'DxpNavBar__ListItemLink',
        item.isActive && 'DxpNavBar__ListItemLink--active',
      ],attrs:{"href":item.href},on:{"click":function($event){return _vm.onClick($event, item)}}},[_vm._v(_vm._s(item.title))]),(item.isActive && item.children && item.children.length > 0)?_c('dxp-nav-bar',{attrs:{"item-list":item.children}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }